<script>
import Phone from '@wielink-application/shared/vue/components/form/input-only/phone.vue'

export default Phone;
</script>